// Trap Coffee — Street Specialty theme JS
// Small, dependency-free helpers: mobile nav, quantity stepper,
// variant picker, and related-products fetch.

document.addEventListener('DOMContentLoaded', function () {
  initNavToggle();
  initQtysteppers();
  document.querySelectorAll('[data-variant-picker]').forEach(initVariantPicker);
  document.querySelectorAll('[data-related-products]').forEach(initRelatedProducts);
});

function initNavToggle() {
  var toggle = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('[data-site-nav]');
  if (!toggle || !nav) return;
  toggle.addEventListener('click', function () {
    var open = nav.getAttribute('data-open') === 'true';
    nav.setAttribute('data-open', String(!open));
    toggle.setAttribute('aria-expanded', String(!open));
  });
}

function initQtysteppers() {
  document.querySelectorAll('[data-qty-stepper]').forEach(function (stepper) {
    var input = stepper.querySelector('input');
    stepper.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = parseInt(btn.getAttribute('data-step'), 10);
        var value = Math.max(1, (parseInt(input.value, 10) || 1) + step);
        input.value = value;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });
}

// Renders the selected variant's price/availability and keeps the
// hidden `id` input in the Add to Cart form in sync with the picked
// option values. Expects the section to embed the product's variant
// data as JSON in a <script type="application/json" data-variant-json>.
function initVariantPicker(root) {
  var dataEl = root.querySelector('[data-variant-json]');
  if (!dataEl) return;
  var variants;
  try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var idInput = root.querySelector('[data-variant-id-input]');
  var priceEl = root.querySelector('[data-price]');
  var addBtn = root.querySelector('[data-add-to-cart]');
  var pills = root.querySelectorAll('[data-option-pill]');

  function currentSelection() {
    var selection = {};
    root.querySelectorAll('[data-option-index]').forEach(function (group) {
      var index = group.getAttribute('data-option-index');
      var active = group.querySelector('.selected');
      if (active) selection[index] = active.getAttribute('data-value');
    });
    return selection;
  }

  function matchVariant(selection) {
    return variants.find(function (v) {
      return Object.keys(selection).every(function (i) {
        return v.options[parseInt(i, 10)] === selection[i];
      });
    });
  }

  function render() {
    var selection = currentSelection();
    var match = matchVariant(selection);
    if (!match) return;
    idInput.value = match.id;
    if (priceEl) priceEl.textContent = formatMoney(match.price);
    if (addBtn) {
      addBtn.disabled = !match.available;
      addBtn.textContent = match.available
        ? (addBtn.getAttribute('data-label-available') || 'Add to Cart')
        : 'Sold Out';
    }
  }

  pills.forEach(function (pill) {
    pill.addEventListener('click', function () {
      var group = pill.closest('[data-option-index]');
      group.querySelectorAll('[data-option-pill]').forEach(function (p) { p.classList.remove('selected'); });
      pill.classList.add('selected');
      render();
    });
  });

  render();
}

// Formats cents according to the shop's own money_format setting
// (window.themeMoneyFormat, set in layout/theme.liquid from `shop.money_format`)
// so prices swapped in by the variant picker match the shop's currency
// display exactly, not just a hardcoded "$X.XX".
function formatMoney(cents) {
  var format = window.themeMoneyFormat || '${{amount}}';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var match = format.match(placeholderRegex);
  var token = match ? match[1] : 'amount';
  var value;

  switch (token) {
    case 'amount_no_decimals':
      value = String(Math.round(cents / 100));
      break;
    case 'amount_with_comma_separator':
      value = (cents / 100).toFixed(2).replace('.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = String(Math.round(cents / 100));
      break;
    case 'amount_with_apostrophe_separator':
      value = (cents / 100).toFixed(2).replace('.', '\'');
      break;
    default:
      value = (cents / 100).toFixed(2);
  }

  return format.replace(placeholderRegex, value);
}

// Fetches Shopify's native product-recommendations endpoint and
// swaps in the returned section markup (the section handles its own
// "no related products" case by rendering nothing).
function initRelatedProducts(root) {
  var productId = root.getAttribute('data-product-id');
  var sectionId = root.getAttribute('data-section-id');
  var limit = root.getAttribute('data-limit') || 4;
  if (!productId || !sectionId) return;
  var url = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
    ? window.Shopify.routes.root + 'recommendations/products?section_id=' + sectionId + '&product_id=' + productId + '&limit=' + limit
    : '/recommendations/products?section_id=' + sectionId + '&product_id=' + productId + '&limit=' + limit;

  fetch(url)
    .then(function (res) { return res.text(); })
    .then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var content = doc.querySelector('[data-related-products-inner]');
      if (content) root.innerHTML = content.innerHTML;
    })
    .catch(function () { /* fail silently — related products are non-critical */ });
}
